import React, { Component } from "react";
import { adminService } from "../../_services/admin.service";
import { LanguageContext } from "../../context/LanguageContext";
import {
  Button,
  Collapse,
  DatePicker,
  Form,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Typography,
  Divider,
  Row,
  Col,
  Statistic,
  Modal,
  Radio,
  message,
} from "antd";
import html2canvas from "html2canvas";
import moment from "moment";
import { connect } from "react-redux";
import {
  ApartmentOutlined,
  DownOutlined,
  ReloadOutlined,
  SafetyOutlined,
  UpOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import { professionalAction } from "../../_actions";
import {
  LineChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  YAxis,
  XAxis,
} from "recharts";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { Title, Text } = Typography;
const { Option } = Select;

class UserSnapShots extends Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      user_data: [],
      startDate: moment(),
      endDate: moment(),
      loader: false,
      activeRange: "daily",
      isExpanded: false,
      download: "excel",
      graph_data: [],
      online_count: 0,
      activePanel: [],
      activeUser: [],
      is_click: false,
      viewType: "performance",
    };
  }
  handleClick = () => {
    this.setState({ is_click: true });
  };
  handleClose = () => {
    this.setState({ is_click: false });
  };
  handleCollapseChange = (keys) => {
    // update active panel manually
    this.setState({ activePanel: keys });
  };
  GetOnlineUserCount = () => {
    let obj = {
      cityId: this.props?.selectedCityId
        ? this.props?.selectedCityId
        : this.props.user.cityId,
    };
    adminService.GetOnlineUserCount(obj).then((res) => {
      this.setState({
        online_count: res.online_count,
        activeUser: res.data,
        loader: false,
      });
    });
  };
  UserSnapShots = async () => {
    const { startDate, endDate, viewType } = this.state;

    this.setState({ loader: true, user_data: [] });

    const obj = {
      city: this.props?.selectedCityId
        ? this.props.selectedCityId
        : this.props.user.cityId,

      startDate: moment(startDate || new Date())
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),

      endDate: moment(endDate || new Date())
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),

      label: viewType === "performance" ? "new list" : "new entry",
    };

    try {
      const res = await adminService.UserSnapShots(obj);

      this.setState({
        user_data: res?.results || [],
        loader: false,
      });
    } catch (error) {
      console.error("UserSnapShots error:", error);

      this.setState({
        user_data: [],
        loader: false,
      });
    }
  };
  DistrictSnapShots = () => {
    const { startDate, endDate, viewType } = this.state;
    this.setState({
      loader: true,
    });
    let obj = {
      district: this.props.user.map_districtId,
      startDate: moment(startDate || new Date())
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate || new Date())
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      label: viewType === "performance" ? "new list" : "new entry",
    };
    adminService.DistrictSnapShots(obj).then((res) => {
      this.setState({
        user_data: res.results,
        loader: false,
      });
    });
  };

  PoliceSideGraphSnapShots = () => {
    const { startDate, endDate, viewType } = this.state;
    this.setState({
      loader: true,
    });
    let obj = {
      district: this.props.user.districtId,
      startDate: moment(startDate || new Date())
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate || new Date())
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      label: viewType === "performance" ? "new list" : "new entry",
    };
    PoliceSideActions.PoliceSideGraphSnapShots(obj).then((res) => {
      this.setState({
        graph_data: res.results,
        loader: false,
      });
    });
  };
  PoliceSideSnapShots = () => {
    const { startDate, endDate, viewType } = this.state;
    this.setState({
      loader: true,
    });
    let obj = {
      district: this.props.user.districtId,
      startDate: moment(startDate || new Date())
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate || new Date())
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      label: viewType === "performance" ? "new list" : "new entry",
    };
    PoliceSideActions.PoliceSideSnapShots(obj).then((res) => {
      this.setState({
        user_data: res.results,
        loader: false,
      });
    });
  };

  handleFind = () => {
    if (this.props.user?.role === "4" || this.props?.selectedCityId) {
      this.UserSnapShots();
    }
    if (this.props.user?.role === "9" || this.props?.user.role === "10") {
      this.DistrictSnapShots();
    }
    if (this.props.user?.role === "2") {
      this.PoliceSideSnapShots();
      this.PoliceSideGraphSnapShots();
    }
  };
  componentDidMount = () => {
    if (this.props.user?.role === "4" || this.props?.selectedCityId) {
      this.UserSnapShots();
      this.GetOnlineUserCount();
    }
    if (this.props.user?.role === "9" || this.props?.user.role === "10") {
      this.DistrictSnapShots();
    }
    if (this.props.user.role === "2") {
      this.PoliceSideSnapShots();
      this.getDistrictsid();
      this.PoliceSideGraphSnapShots();
      this.props.dispatch(professionalAction.getCity());
    }
  };
  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        startDate: startDate,
        endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        endDate: endDate,
      });
    }
  };
  setQuickRange = (type) => {
    let startDate = null;
    let endDate = moment();

    switch (type) {
      case "daily":
        startDate = moment();
        break;
      case "month":
        startDate = moment().startOf("month");
        break;
      case "6month":
        startDate = moment().subtract(6, "months");
        break;
      case "year":
        startDate = moment().subtract(1, "year");
        break;
      default:
        return;
    }

    this.setState({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      activeRange: type,
    });
  };

  onRangeChange = (dates) => {
    if (!dates) {
      this.setState({ startDate: null, endDate: null });
      return;
    }

    this.setState({
      startDate: dates[0].format("YYYY-MM-DD"),
      endDate: dates[1].format("YYYY-MM-DD"),
    });
  };

  getNoticeExportRows = () => {
    const { t } = this.context;
    const { viewType } = this.state;
    let list = [];
    list =
      viewType === "performance"
        ? this.state.user_data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("police_station")]: data.DistrictName,
            [t("total_accused_count")]: data.newAdded,
            [t("crimes")]: data.gunhaUpdated,
            [t("preventive_action")]: data.preventive,
            [t("arrested_accused")]: data.arrested,
            [t("ncr")]: data.ncr,
            [t("notice")]: data.notice,
            [t("photo_upload")]: data.photoTotal,
          }))
        : this.state.user_data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("district")]: data.DistrictName,
            [t("crimes")]: data.gunhaUpdated,
            [t("arrested_accused")]: data.arrested,
            [t("notice")]: data.notice,
            [t("ncr")]: data.ncr,
            [t("preventive_action")]: data.preventive,
          }));
    var arrData = list;
    return arrData;
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getNoticeExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = "Snapshots_report";
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });

    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.startDate,
          this.state.activeRange != "daily"
            ? this.state.report_4_endDate
            : null,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download, crimeTitle } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download === "pdf") {
      this.download_pdf();
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = () => {
    const { t, language } = this.context;
    const { showList, filter, viewType } = this.state;
    const report_name = "Snapshots_report";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "Snapshots Report";

    let list = [];
    list =
      viewType === "performance"
        ? this.state.user_data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("police_station")]: data.DistrictName,
            [t("total_accused_count")]: data.newAdded,
            [t("crimes")]: data.gunhaUpdated,
            [t("preventive_action")]: data.preventive,
            [t("arrested_accused")]: data.arrested,
            [t("ncr")]: data.ncr,
            [t("notice")]: data.notice,
            [t("photo_upload")]: data.photoTotal,
          }))
        : this.state.user_data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("district")]: data.DistrictName,
            [t("crimes")]: data.gunhaUpdated,
            [t("arrested_accused")]: data.arrested,
            [t("notice")]: data.notice,
            [t("ncr")]: data.ncr,
            [t("preventive_action")]: data.preventive,
          }));
    var arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    const cellStyle = {
      font: { sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });
    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((value, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        }); // Data starts at row 4
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = cellStyle;
      });
    });

    ws["A1"] = {
      v: this.getCityName(
        this.props?.selectedCityId
          ? this.props?.selectedCityId
          : this.props?.user?.cityId || "",
      ),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };
    console.log("language", language);
    let dates =
      this.state.activeRange == "daily"
        ? moment(this.state.startDate).format("DD-MM-YYYY")
        : `${t("from")} ${moment(this.state.startDate).format(
            "DD-MM-YYYY",
          )} - ${t("to")} ${moment(this.state.endDate).format("DD-MM-YYYY")}`;

    ws["A3"] = {
      v: dates,
      t: "s",
      s: headerStyle,
    };

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);

    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  downloadCardImage = () => {
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;

    const card = document.getElementById("snapshot-card");
    if (!card) return;

    const dateDiv = document.createElement("div");
    dateDiv.innerText = `Created at:${moment().format("DD-MM-YYYY")}`;
    dateDiv.style.textAlign = "center";
    dateDiv.style.fontSize = "15px";
    dateDiv.style.color = "rgb(31, 31, 31)";
    dateDiv.style.marginTop = "10px";
    dateDiv.style.fontWeight = "600";

    card.appendChild(dateDiv);

    html2canvas(card, {
      scale: 2,
      backgroundColor: "#ffffff",
    }).then((canvas) => {
      card.removeChild(dateDiv);

      const link = document.createElement("a");
      link.download = `${stateName}_snapshot.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  // getInlineGraphData = (label, value) => {
  //   const v = Number(value) || 0;
  //   return [
  //     { x: 1, y: Math.max(v - 4, 0), label },
  //     { x: 2, y: Math.max(v - 2, 0), label },
  //     { x: 3, y: v, label },
  //     { x: 4, y: v + 2, label },
  //     { x: 5, y: v, label },
  //   ];
  // };
  getInlineGraphData = (type, graphData = []) => {
    console.log("type", type);
    const filtered = graphData
      .filter((g) => g.type === type)
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    // 0 points → flat placeholder
    if (filtered.length === 0) {
      return [
        { x: 1, y: 0 },
        { x: 2, y: 0 },
      ];
    }

    // 1 point → duplicate for line visibility
    if (filtered.length === 1) {
      const point = filtered[0];
      return [
        { x: 1, y: point.count, date: point.date },
        { x: 2, y: point.count, date: point.date },
      ];
    }

    // 2+ points → normal
    return filtered.map((item, index) => ({
      x: index + 1,
      y: item.count,
      date: item.date,
    }));
  };

  CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length || payload[0].payload.y === 0) {
      return null;
    }

    const { y, date } = payload[0].payload;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          padding: "6px 10px",
          borderRadius: 6,
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          fontSize: 12,
          whiteSpace: "nowrap",
        }}
      >
        <div>
          <strong>{date}</strong>
        </div>
        <div>Count: {y}</div>
      </div>
    );
  };

  render() {
    const { t } = this.context;
    const {
      user_data,
      graph_data,
      online_count,
      activePanel,
      activeUser,
      viewType,
    } = this.state;
    console.log("user_data", user_data);
    console.log("graph_data", graph_data);

    const cityName = this.getCityName(
      this.props?.selectedCityId
        ? this.props?.selectedCityId
        : this.props?.user?.cityId || "",
    );
    let tableListData =
      activeUser &&
      activeUser.map((item, index) => ({
        ...item,
        srNo: index + 1,
      }));
    const columnsOb1 = [
      {
        title: t("sr.no"),
        key: "srNo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: "पोलिस ठाणे",
        key: "DistrictName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.DistrictName}
          </Space>
        ),
      },
      {
        title: "प्रभारी",
        key: "name",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.name}
          </Space>
        ),
      },

      {
        title: "मोबाईल नंबर",
        key: "phone",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.phone}
          </Space>
        ),
      },
      {
        title: "शेवटचे लॉगिन वेळ",
        key: "last_active",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.last_active
              ? new Date(record.last_active.replace(" ", "T")).toLocaleString(
                  "en-IN",
                  {
                    timeZone: "Asia/Kolkata",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  },
                )
              : "-"}
          </Space>
        ),
      },

      // {
      //   title: "User Type",
      //   key: "userType",
      //   render: (text, record) => {
      //     const isPolice = record.role === "2";

      //     return (
      //       <Space size="middle" style={{ maxWidth: 300 }}>
      //         <Tag
      //           color={isPolice ? "blue" : "green"}
      //           icon={isPolice ? <SafetyOutlined /> : <ApartmentOutlined />}
      //         >
      //           {isPolice ? "Police" : "Office"}
      //         </Tag>
      //       </Space>
      //     );
      //   },
      // },
    ];
    const CountTag = ({ value, color }) => (
      <Tag
        color={color}
        style={{
          borderRadius: "12px",
          minWidth: 28,
          textAlign: "center",
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        {value ?? 0}
      </Tag>
    );
    const columnsOb =
      viewType === "performance"
        ? [
            {
              title: t("sr.no"),
              dataIndex: "sr_no",
              key: "sr_no",
              align: "center",
              width: 70,
              sorter: (a, b) => a.sr_no - b.sr_no,
            },
            {
              title: t("accused_police_station"),
              dataIndex: "DistrictName",
              key: "DistrictName",
              sorter: (a, b) =>
                (a.DistrictName || "").localeCompare(b.DistrictName || ""),
            },
            {
              title: t("total_accused_count"),
              dataIndex: "newAdded",
              key: "newAdded",
              align: "center",
              sorter: (a, b) => (a.newAdded || 0) - (b.newAdded || 0),
              render: (v) => <CountTag value={v} color="geekblue" />,
            },
            {
              title: t("crimes"),
              dataIndex: "gunhaUpdated",
              key: "gunhaUpdated",
              align: "center",
              sorter: (a, b) => (a.gunhaUpdated || 0) - (b.gunhaUpdated || 0),
              render: (v) => <CountTag value={v} color="green" />,
            },

            {
              title: t("arrested_accused"),
              dataIndex: "arrested",
              key: "arrested",
              align: "center",
              sorter: (a, b) => (a.arrested || 0) - (b.arrested || 0),
              render: (v) => <CountTag value={v} color="red" />,
            },

            {
              title: t("notice"),
              dataIndex: "notice",
              key: "notice",
              align: "center",
              sorter: (a, b) => (a.notice || 0) - (b.notice || 0),
              render: (v) => <CountTag value={v} color="purple" />,
            },
            {
              title: t("ncr"),
              dataIndex: "ncr",
              key: "ncr",
              align: "center",
              sorter: (a, b) => (a.ncr || 0) - (b.ncr || 0),
              render: (v) => <CountTag value={v} color="red" />,
            },
            {
              title: t("preventive_action"),
              dataIndex: "preventive",
              key: "preventive",
              align: "center",
              sorter: (a, b) => (a.preventive || 0) - (b.preventive || 0),
              render: (v) => <CountTag value={v} color="gold" />,
            },
            {
              title: t("photo_upload"),
              dataIndex: "photoTotal",
              key: "photoTotal",
              align: "center",
              sorter: (a, b) => (a.photoTotal || 0) - (b.photoTotal || 0),
              render: (v) => <CountTag value={v} color="cyan" />,
            },
            {
              title: t("last_login"),
              dataIndex: "login_time",
              key: "login_time",
              align: "center",
              sorter: (a, b) =>
                new Date(a.login_time || 0) - new Date(b.login_time || 0),
              render: (v) => (
                <CountTag
                  value={
                    v
                      ? new Date(v.replace(" ", "T")).toLocaleString("en-IN", {
                          timeZone: "Asia/Kolkata",
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : "-"
                  }
                  color={v ? "volcano" : "default"}
                />
              ),
            },
          ]
        : [
            {
              title: t("sr.no"),
              dataIndex: "sr_no",
              key: "sr_no",
              align: "center",
              width: 70,
              sorter: (a, b) => a.sr_no - b.sr_no,
            },
            {
              title: t("accused_police_station"),
              dataIndex: "DistrictName",
              key: "DistrictName",
              sorter: (a, b) =>
                (a.DistrictName || "").localeCompare(b.DistrictName || ""),
            },
            {
              title: t("crimes"),
              dataIndex: "gunhaUpdated",
              key: "gunhaUpdated",
              align: "center",
              sorter: (a, b) => (a.gunhaUpdated || 0) - (b.gunhaUpdated || 0),
              render: (v) => <CountTag value={v} color="green" />,
            },
            {
              title: t("arrested_accused"),
              dataIndex: "arrested",
              key: "arrested",
              align: "center",
              sorter: (a, b) => (a.arrested || 0) - (b.arrested || 0),
              render: (v) => <CountTag value={v} color="red" />,
            },
            {
              title: t("notice"),
              dataIndex: "notice",
              key: "notice",
              align: "center",
              sorter: (a, b) => (a.notice || 0) - (b.notice || 0),
              render: (v) => <CountTag value={v} color="purple" />,
            },
            {
              title: t("ncr"),
              dataIndex: "ncr",
              key: "ncr",
              align: "center",
              sorter: (a, b) => (a.ncr || 0) - (b.ncr || 0),
              render: (v) => <CountTag value={v} color="red" />,
            },
            {
              title: t("preventive_action"),
              dataIndex: "preventive",
              key: "preventive",
              align: "center",
              sorter: (a, b) => (a.preventive || 0) - (b.preventive || 0),
              render: (v) => <CountTag value={v} color="gold" />,
            },
          ];

    return (
      <>
        {!this.props?.selectedCityId ? (
          <>
            <Collapse
              activeKey={activePanel} // controlled
              onChange={this.handleCollapseChange}
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => (
                <DownOutlined
                  style={{
                    fontSize: "14px",
                    color: "#1677ff",
                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              )}
              style={{
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <Collapse.Panel
                key="1"
                header={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {/* Left side */}

                    <div
                      style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: "#1f1f1f",
                        flexWrap: "wrap",
                      }}
                    >
                      Snapshot
                    </div>
                    {this.props.user.role === "4" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "14px",
                          padding: "8px 14px",
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #f0f5ff, #ffffff)",
                          border: "1px solid #adc6ff",
                          minWidth: "210px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                        }}
                      >
                        {/* Count Section */}
                        <span
                          onClick={this.handleClick}
                          style={{
                            fontWeight: 700,
                            fontSize: "15px",
                            cursor: "pointer",
                            color: "#10239e",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          🟢 {online_count ?? 0} Online Users
                        </span>

                        {/* Refresh Button */}
                        <Button
                          size="small"
                          shape="circle"
                          type="primary"
                          icon={<ReloadOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.GetOnlineUserCount();
                          }}
                        />
                      </div>
                    )}

                    {/* Right side: Online count + Refresh button */}
                  </div>
                }
                style={{ borderBottom: "none" }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#1f1f1f",
                    flexWrap: "wrap",
                    textAlign: "center",
                    justifyContent: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Radio.Group
                    value={this.state.viewType}
                    onChange={(e) => {
                      this.setState({ viewType: e.target.value }, () => {
                        if (this.props.user?.role === "4") {
                          this.UserSnapShots();
                        }
                        if (
                          this.props.user?.role === "9" ||
                          this.props?.user.role === "10"
                        ) {
                          this.DistrictSnapShots();
                        }
                        if (this.props.user?.role === "2") {
                          this.PoliceSideSnapShots();
                          this.PoliceSideGraphSnapShots();
                        }
                      });
                    }}
                  >
                    <Radio value="performance">Data Entry Snapshot</Radio>
                    <Radio value="dataEntry">Event-Based Snapshot </Radio>
                  </Radio.Group>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    padding: "12px",
                    background: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    marginBottom: "12px",
                  }}
                >
                  <span style={{ fontSize: "14px", fontWeight: 500 }}>
                    {t("select_date")}:
                  </span>
                  {/* Quick Buttons */}
                  <Space>
                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "daily"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("daily")}
                    >
                      Daily
                    </Button>

                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "month"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("month")}
                    >
                      Month
                    </Button>

                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "6month"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("6month")}
                    >
                      6 Month
                    </Button>

                    <Button
                      size="small"
                      type={
                        this.state.activeRange === "year"
                          ? "primary"
                          : "default"
                      }
                      onClick={() => this.setQuickRange("year")}
                    >
                      1 Year
                    </Button>
                  </Space>
                  {/* Range Picker */}
                  <DatePicker
                    value={
                      this.state.startDate
                        ? moment(this.state.startDate)
                        : moment()
                    }
                    onChange={this.onStartDateChange}
                    placeholder="DD/MM/YYYY"
                    inputReadOnly
                    format="DD/MM/YYYY"
                    style={{ minWidth: "150px" }}
                  />{" "}
                  <DatePicker
                    value={
                      this.state.endDate ? moment(this.state.endDate) : moment()
                    }
                    onChange={this.onEndDateChange}
                    placeholder="DD/MM/YYYY"
                    inputReadOnly
                    format="DD/MM/YYYY"
                    style={{ minWidth: "150px" }}
                  />
                  <Button
                    type="primary"
                    disabled={!this.state.startDate}
                    loading={this.state.loader}
                    onClick={this.handleFind}
                  >
                    {t("find")}
                  </Button>
                  {this.props.user.role != "2" && (
                    <>
                      <Form.Item style={{ marginBottom: 0 }}>
                        <Select
                          defaultValue={this.state.download}
                          placeholder={t("please_select_an_option")}
                          value={this.state.download || "excel"}
                          onChange={(value) =>
                            this.setState({ download: value })
                          }
                          style={{ minWidth: "160px" }}
                        >
                          <Option key="excel">{t("excel")}</Option>
                          <Option key="pdf">PDF</Option>
                        </Select>
                      </Form.Item>
                      {this.state.download && (
                        <Button
                          type="primary"
                          onClick={() => this.downloadReport()}
                          disabled={!this.state.user_data?.length}
                        >
                          {t("download")}
                        </Button>
                      )}
                    </>
                  )}
                  {this.props.user.role === "2" && (
                    <div style={{ textAlign: "right" }}>
                      <Button type="primary" onClick={this.downloadCardImage}>
                        Download Snapshot
                      </Button>
                    </div>
                  )}
                </div>
                {this.props.user.role != "2" ? (
                  <Table
                    loading={Boolean(this.state.loader)}
                    columns={columnsOb}
                    dataSource={user_data}
                    rowKey="sr_no"
                    pagination={{ showSizeChanger: true }}
                  />
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 24,
                      }}
                    >
                      <Card
                        id="snapshot-card"
                        bordered={false}
                        style={{
                          width: 550,
                          borderRadius: 16,
                          background: "#fff",
                          boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                        }}
                        bodyStyle={{ padding: 20 }}
                      >
                        {/* Header */}
                        <div style={{ textAlign: "center", marginBottom: 16 }}>
                          <Title level={4} style={{ marginBottom: 2 }}>
                            {viewType === "performance"
                              ? "Data Entry Snapshot"
                              : "Event-Based Snapshot"}
                          </Title>
                          <Text strong>
                            {this.state.district_name} ({cityName})
                          </Text>
                          <p>
                            {moment(this.state.startDate).format("DD-MM-YYYY")}{" "}
                            To {moment(this.state.endDate).format("DD-MM-YYYY")}
                          </p>
                        </div>

                        <Divider />

                        {[
                          {
                            key: "newAdded",
                            label: t("total_accused_count"),
                            value: user_data[0]?.newAdded,
                            color: "#2f54eb",
                          },
                          {
                            key: "gunhaUpdated",
                            label: t("crimes"),
                            value: user_data[0]?.gunhaUpdated,
                            color: "#52c41a",
                          },
                          {
                            key: "arrested",
                            label: t("arrested_accused"),
                            value: user_data[0]?.arrested,
                            color: "#f5222d",
                          },
                          {
                            key: "notice",
                            label: t("notice"),
                            value: user_data[0]?.notice,
                            color: "#722ed1",
                          },
                          {
                            key: "NCR",
                            label: t("ncr"),
                            value: user_data[0]?.NCR,
                            color: "#e626d3",
                          },
                          {
                            key: "preventive",
                            label: t("preventive_action"),
                            value: user_data[0]?.preventive,
                            color: "#faad14",
                          },

                          {
                            key: "photoTotal",
                            label: t("photo_upload"),
                            value: user_data[0]?.photoTotal,
                            color: "#13c2c2",
                          },
                        ]
                          .filter(
                            (item) =>
                              viewType === "performance" ||
                              (item.key !== "photoTotal" &&
                                item.key !== "newAdded"),
                          )
                          .map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: 52,
                                marginBottom: 6,
                              }}
                            >
                              {/* LEFT : Label + Count */}
                              <div style={{ flex: 1 }}>
                                <Row
                                  align="middle"
                                  style={{ textAlign: "center" }}
                                >
                                  {/* LABEL */}
                                  <Col span={6} style={{ color: item.color }}>
                                    <strong>{item.label}</strong>
                                  </Col>

                                  {/* COUNT */}
                                  <Col span={6}>
                                    <div
                                      style={{
                                        width: 80,
                                        textAlign: "right",
                                        fontSize: 18,
                                        fontWeight: 600,
                                        color: item.color,
                                      }}
                                    >
                                      {item.value || 0}
                                    </div>
                                  </Col>

                                  {/* GRAPH */}
                                  <Col span={12}>
                                    <div
                                      style={{
                                        // width: 80,
                                        height: 28,
                                      }}
                                    >
                                      <ResponsiveContainer
                                        width="100%"
                                        height="100%"
                                      >
                                        <LineChart
                                          data={this.getInlineGraphData(
                                            item.key,
                                            this.state.graph_data,
                                          )}
                                          margin={{
                                            top: 6,
                                            right: 4,
                                            left: 4,
                                            bottom: 6,
                                          }}
                                        >
                                          <XAxis hide />
                                          <YAxis
                                            hide
                                            domain={["dataMin", "dataMax"]}
                                          />
                                          <Tooltip
                                            content={<this.CustomTooltip />}
                                            position={{ y: -40 }} // 👈 move tooltip upward
                                            cursor={false} // 👈 no hover line
                                            wrapperStyle={{
                                              zIndex: 9999,
                                              pointerEvents: "none", // 👈 prevents overlap/flicker
                                            }}
                                          />

                                          <Line
                                            type="monotone"
                                            dataKey="y"
                                            stroke={item.color}
                                            strokeWidth={3}
                                            dot={false}
                                            isAnimationActive={false}
                                          />
                                        </LineChart>
                                      </ResponsiveContainer>
                                    </div>
                                  </Col>
                                  <Divider style={{ marginTop: 6 }} />
                                </Row>
                              </div>

                              {/* RIGHT : GRAPH */}
                            </div>
                          ))}
                      </Card>
                    </div>
                  </>
                )}
              </Collapse.Panel>
            </Collapse>
          </>
        ) : (
          <>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#1f1f1f",
                flexWrap: "wrap",
                textAlign: "center",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              <Radio.Group
                value={this.state.viewType}
                onChange={(e) => {
                  this.setState({ viewType: e.target.value }, () => {
                    if (this.props.user?.role === "4") {
                      this.UserSnapShots();
                    }
                    if (
                      this.props.user?.role === "9" ||
                      this.props?.user.role === "10"
                    ) {
                      this.DistrictSnapShots();
                    }
                    if (this.props.user?.role === "2") {
                      this.PoliceSideSnapShots();
                      this.PoliceSideGraphSnapShots();
                    }
                  });
                }}
              >
                <Radio value="performance">Data Entry Snapshot</Radio>
                <Radio value="dataEntry">Event-Based Snapshot </Radio>
              </Radio.Group>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "wrap",
                padding: "12px",
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                marginBottom: "12px",
              }}
            >
              <span style={{ fontSize: "14px", fontWeight: 500 }}>
                {t("select_date")}:
              </span>
              {/* Quick Buttons */}
              <Space>
                <Button
                  size="small"
                  type={
                    this.state.activeRange === "daily" ? "primary" : "default"
                  }
                  onClick={() => this.setQuickRange("daily")}
                >
                  Daily
                </Button>

                <Button
                  size="small"
                  type={
                    this.state.activeRange === "month" ? "primary" : "default"
                  }
                  onClick={() => this.setQuickRange("month")}
                >
                  Month
                </Button>

                <Button
                  size="small"
                  type={
                    this.state.activeRange === "6month" ? "primary" : "default"
                  }
                  onClick={() => this.setQuickRange("6month")}
                >
                  6 Month
                </Button>

                <Button
                  size="small"
                  type={
                    this.state.activeRange === "year" ? "primary" : "default"
                  }
                  onClick={() => this.setQuickRange("year")}
                >
                  1 Year
                </Button>
              </Space>
              {/* Range Picker */}
              <DatePicker
                value={
                  this.state.startDate ? moment(this.state.startDate) : moment()
                }
                onChange={this.onStartDateChange}
                placeholder="DD/MM/YYYY"
                inputReadOnly
                format="DD/MM/YYYY"
                style={{ minWidth: "150px" }}
              />{" "}
              <DatePicker
                value={
                  this.state.endDate ? moment(this.state.endDate) : moment()
                }
                onChange={this.onEndDateChange}
                placeholder="DD/MM/YYYY"
                inputReadOnly
                format="DD/MM/YYYY"
                style={{ minWidth: "150px" }}
              />
              <Button
                type="primary"
                disabled={!this.state.startDate}
                loading={this.state.loader}
                onClick={this.handleFind}
              >
                {t("find")}
              </Button>
              {this.props.user.role != "2" && (
                <>
                  <Form.Item style={{ marginBottom: 0 }}>
                    <Select
                      defaultValue={this.state.download}
                      placeholder={t("please_select_an_option")}
                      value={this.state.download || "excel"}
                      onChange={(value) => this.setState({ download: value })}
                      style={{ minWidth: "160px" }}
                    >
                      <Option key="excel">{t("excel")}</Option>
                      <Option key="pdf">PDF</Option>
                    </Select>
                  </Form.Item>
                  {this.state.download && (
                    <Button
                      type="primary"
                      onClick={() => this.downloadReport()}
                      disabled={!this.state.user_data?.length}
                    >
                      {t("download")}
                    </Button>
                  )}
                </>
              )}
              {this.props.user.role === "2" && (
                <div style={{ textAlign: "right" }}>
                  <Button type="primary" onClick={this.downloadCardImage}>
                    Download Snapshot
                  </Button>
                </div>
              )}
            </div>
            <Table
              loading={this.state.loader}
              columns={columnsOb}
              dataSource={user_data}
              rowKey="sr_no"
              pagination={{ showSizeChanger: true }}
            />
          </>
        )}

        <Modal
          title="Active User List"
          top
          visible={this.state.is_click}
          onOk={this.handleClose}
          onCancel={this.handleClose}
          width={95 + "%"}
        >
          <Table
            columns={columnsOb1}
            dataSource={tableListData}
            rowKey="sr_no"
            pagination={{ showSizeChanger: true }}
          />
        </Modal>
      </>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedDashboard = connect(mapStateToProps)(UserSnapShots);
export { connectedDashboard as UserSnapShots };
